import React from 'react'

type Props = {
  children: React.ReactNode[] | React.ReactNode
  xsCols?: number
  smCols?: number
  mdCols?: number
  lgCols?: number
}
const Grid:React.FC<Props> = ({ children, xsCols = 1, smCols = 3, mdCols = 4, lgCols = 5 }) => {
  return (
    <div className={`grid grid-cols-${xsCols} sm:grid-cols-${smCols} md:grid-cols-${mdCols} lg:grid-cols-${lgCols} gap-6 mt-4`}>
      {children}
    </div>
  )
}

export default Grid
